// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueResource from 'vue-resource';

// Global custom components
import * as VueGoogleMaps from 'vue2-google-maps';
import Spinner from './global/components/Spinner';
import ImageUploader from './global/components/ImageUploader';
import Ckeditor from './global/components/Ckeditor';
import MenuItem from './views/menu/MenuItem';
import TermsOrderItem from './views/taxonomy/vocabulary/TermsOrderItem';
import SelectelFolder from './views/publicFiles/Folder';
import FileUploaderFolder from './global/components/FileUploader/Folder';

import apiHttp from './apiHttp';
import router from './router';
import config from './config';
import store from './store';
import App from './App';

import VueSelect from 'vue-select'

// Load global components
Vue.component('image-uploader', ImageUploader);
Vue.component('ckeditor', Ckeditor);
Vue.component('menu-item', MenuItem);
Vue.component('term-item', TermsOrderItem);
Vue.component('SelectelFolder', SelectelFolder);
Vue.component('FileUploaderFolder', FileUploaderFolder);
Vue.component('spinner', Spinner);

Vue.component('v-select', VueSelect)

Vue.use(VueResource);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAtKJall6X5HN_b5hJW21Eq345uDsaf92c',
    v: '3',
    libraries: 'places',
  },
});

Vue.prototype.$apiHttp = apiHttp;
Vue.prototype.$logout = function () {
  localStorage.setItem('tokenStorage', '');
  localStorage.setItem('user', '');
  this.$store.commit('user/storeAccessToken', '');
  this.$store.commit('user/setInfo', '');
  this.$store.commit('errors/setAuthError', 'Your access token is expired. Please, log in again');
  this.$router.push('/login');
};
Vue.prototype.$assignAxiosHeaders = function (accessToken) {
  Object.assign(this.$apiHttp.defaults, {
    headers: {
      authorization: `Bearer ${accessToken}`,
      Accept: 'application/json',
    },
  });
};

/* eslint-disable no-new */
new Vue({
  el: '#app',
  config,
  router,
  store,
  components: { App },
  created() {
    // Default error handling for 401 error
    this.$apiHttp.interceptors.response.use(null, (error) => {
      if (error.response.status === 401) {
        this.$logout();
      }
      if (error.response.status === 403) {
        this.$store.commit('notifications/setDangerNotification', 'Access denied!');
      }
      return Promise.reject(error);
    });

    // Update apiHttp's headers when aceesToken is changed
    this.$store.watch(state => state.user.accessToken, (newVal) => {
      if (newVal.access_token) {
        this.$assignAxiosHeaders(newVal.access_token);
      }
    }, { deep: true });
  },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js